import { POST_TYPE, SOCIAL_NETWORK } from './post'

type Restrictions = {
  [keyof in SOCIAL_NETWORK]: {
    media_restrictions: {
      [key in POST_TYPE | 'default']: any
    }
    content_restrictions: {
      [key in POST_TYPE | 'default']: any
    }
  }
}

interface DefaultValues {
  video: {
    valid_file_type: ['mp4', 'mov']
    // max_videos_per_post: 1
    max_size_mb: 1024
    max_size_px: {
      width: null
      height: null
    }
    min_size_px: {
      width: null
      height: null
    }
    max_duration_sec: 1200
    min_duration_sec: null
    recommended_size: null
    aspect_ratio: null
    gif_is_animated: null
  }
  image: {
    valid_file_type: ['jpg', 'jpeg', 'png']
    max_mediafiles_per_post_carousel: 1
    max_size_mb: 10
    max_size_px: {
      width: null
      height: null
    }
    min_size_px: {
      width: 600
      height: 315
    }
    gif_is_animated: null
    recommended_size: null
    aspect_ratio: null
  }
}

const restrictions = {
  facebook: {
    media_restrictions: {
      default: {
        video: {
          valid_file_type: [
            'mov',
            'quicktime',
            'mp4',
            'x-msvideo',
            '3gpp',
            'mpeg',
            'ogg',
            'webm',
            'x-m4v',
            'ms-asf',
            'x-ms-wmv',
            'x-matroska'
          ],
          // max_videos_per_post: 1,
          max_size_mb: 1024,
          max_size_px: {
            width: null,
            height: null
          },
          min_size_px: {
            width: null,
            height: null
          },
          max_duration_sec: 1200,
          min_duration_sec: null,
          recommended_size: null,
          aspect_ratio: null
        },
        image: {
          valid_file_type: ['jpg', 'jpeg', 'png'],
          max_mediafiles_per_post_carousel: 1,
          max_size_mb: 10,
          max_size_px: {
            width: null,
            height: null
          },
          min_size_px: {
            width: 600,
            height: 315
          },
          recommended_size: null,
          aspect_ratio: null
        }
      },
      link: null,
      single_photo: {
        image: {
          recommended_size: {
            '1.91:1': {
              width: 1200,
              height: 628
            },
            '2:3': {
              width: 1200,
              height: 1800
            },
            '1:1': {
              width: 1200,
              height: 1200
            }
          },
          aspect_ratio: ['1.91:1', '2:3', '1:1']
        }
      },
      multi_photo: {
        image: {
          recommended_size: {
            '1.91:1': {
              width: 1200,
              height: 628
            },
            '2:3': {
              width: 1200,
              height: 1800
            },
            '1:1': {
              width: 1200,
              height: 1200
            }
          },
          aspect_ratio: ['1.91:1', '2:3', '1:1']
        }
      },
      single_video: {
        video: {
          recommended_size: {
            '16:9': {
              width: 1200,
              height: 720
            }
          },
          aspect_ratio: ['16:9']
        }
      },
      animated_gif: {
        image: {
          valid_file_type: ['gif'],
          gif_is_animated: true
        }
      },
      text: null,
      link_carousel: {
        images: {
          valid_file_type: ['jpg', 'jpeg', 'png', 'gif'],
          gif_is_animated: false
        }
      },
      photo_story: {
        image: {
          recommended_size: {
            '9:16': {
              width: 1080,
              height: 1920
            }
          },
          aspect_ratio: ['9:16']
        }
      },
      video_story: {
        video: {
          recommended_size: {
            '9:16': {
              width: 1080,
              height: 1920
            }
          },
          aspect_ratio: ['9:16']
        }
      }
    },
    content_restrictions: {
      link: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false
        },
        cards: null,
        video: null,
        image: null,
        link: {
          link: true
        },
        tag_people: false,
        enter_location: false,
        targeting_and_visability: {
          targeting: true,
          dark_post: true
        }
      },
      single_photo: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false,
          max_mediafiles: 1,
          image: true
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: {
          targeting: true,
          dark_post: true
        }
      },
      multi_photo: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false,
          max_mediafiles: 6,
          image: true
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: {
          targeting: true,
          dark_post: true
        }
      },
      single_video: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          max_mediafiles: 1,
          hashtags: false,
          gif: true
        },
        cards: null,
        video: {
          file: true,
          title: true,
          category: true
        },
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: {
          targeting: true,
          dark_post: true
        }
      },
      animated_gif: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          max_mediafiles: 1,
          emoji: false,
          hashtags: false,
          gif: true
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: {
          targeting: true,
          dark_post: true
        }
      },
      text: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false,
          image: false
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: {
          targeting: true,
          dark_post: true
        }
      },
      link_carousel: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false,
          max_mediafiles: 1,
          image: true,
          gif: true
        },
        cards: {
          max_cards: 5,
          min_cards: 3,
          end_card_link: true
        },
        video: null,
        link: {
          link: true,
          link_name: true,
          link_description: true
        },
        tag_people: false,
        enter_location: false,
        targeting_and_visability: {
          targeting: true,
          dark_post: true
        }
      },
      photo_story: {
        message: {
          max_mediafiles: 1,
          image: true
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: null
      },
      video_story: {
        message: {
          max_mediafiles: 1,
        },
        cards: null,
        video: {
          file: true
        },
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: null
      }
    }
  },

  instagram: {
    media_restrictions: {
      default: {
        video: {
          valid_file_type: [
            'mov',
            'quicktime',
            'mp4',
            'x-msvideo',
            '3gpp',
            'mpeg',
            'ogg',
            'webm',
            'x-m4v',
            'ms-asf',
            'x-ms-wmv',
            'x-matroska'
          ],
          // max_videos_per_post: 1,
          max_size_mb: 4096,
          max_size_px: {
            width: null,
            height: null
          },
          min_size_px: {
            width: 600,
            height: 315
          },
          max_duration_sec: 60,
          min_duration_sec: 3,
          recommended_size: null,
          aspect_ratio: null
        },
        image: {
          valid_file_type: ['jpg', 'jpeg', 'png'],
          max_mediafiles_per_post_carousel: 1,
          max_size_mb: 10,
          max_size_px: {
            width: 1080,
            height: 1080
          },
          min_size_px: {
            width: 320,
            height: 320
          },
          recommended_size: null,
          aspect_ratio: null
        }
      },
      media_carousel: {
        image: {
          aspect_ratio: ['9:16'],
          recomended_size: {
            '9:16': {
              width: 1080,
              height: 1920
            }
          },
          valid_file_type: ['jpg', 'jpeg', 'png']
        },
        video: {
          aspect_ratio: ['9:16'],
          max_duration_sec: 15,
          min_size_px: { width: 600, height: 1067 },
          recommended_size: {
            '9:16': { width: 1080, height: 1920 }
          }
        }
      },
      single_photo: {
        image: {
          valid_file_type: ['jpg', 'jpeg', 'png', 'gif'],
          gif_is_animated: false,
          recommended_size: {
            '1:1': {
              width: 1080,
              height: 1080
            },
            '1.91:1': {
              width: 1080,
              height: 608
            },
            '4:5': {
              width: 1080,
              height: 1350
            }
          },
          aspect_ratio: ['1:1', '1.91:1', '4:5']
        }
      },
      single_video: {
        video: {
          min_size_px: {
            width: 600,
            height: 750
          },
          recommended_size: {
            '9:16': {
              width: 1080,
              height: 1920
            },
            '1.91:1': {
              width: 600,
              height: 315
            },
            '1:1': {
              width: 600,
              height: 600
            }
          },
          aspect_ratio: ['4:5', '1.91:1', '1:1']
        }
      },
      multi_photo: {
        image: {
          valid_file_type: ['jpg', 'jpeg', 'png', 'gif'],
          recommended_size: {
            '1:1': {
              width: 1080,
              height: 1080
            },
            '1.91:1': {
              width: 1080,
              height: 608
            },
            '4:5': {
              width: 1080,
              height: 1350
            }
          },
          aspect_ratio: ['1:1', '1.91:1', '4:5']
        }
      },
      multi_video: {
        video: {
          min_size_px: {
            width: 600,
            height: 750
          },
          recommended_size: {
            '9:16': {
              width: 1080,
              height: 1920
            },
            '1.91:1': {
              width: 600,
              height: 315
            },
            '1:1': {
              width: 600,
              height: 600
            }
          },
          aspect_ratio: ['4:5', '1.91:1', '1:1']
        }
      },
      photo_story: {
        image: {
          valid_file_type: ['jpg', 'jpeg', 'png'],
          gif_is_animated: true,
          recommended_size: {
            '9:16': {
              width: 1080,
              height: 1920
            }
          },
          aspect_ratio: ['9:16']
        },
        gif: null
      },
      video_story: {
        video: {
          min_size_px: {
            width: 600,
            height: 1067
          },
          max_duration_sec: 15,
          recommended_size: {
            '9:16': {
              width: 1080,
              height: 1920
            }
          },
          aspect_ratio: ['9:16']
        }
      },
      reels: {
        video: {
          min_size_px: {
            width: 600,
            height: 1067
          },
          recommended_size: {
            '9:16': {
              width: 1080,
              height: 1920
            },
            '1.91:1': {
              width: 600,
              height: 315
            },
            '1:1': {
              width: 600,
              height: 600
            }
          },
          aspect_ratio: ['4:5', '1.91:1', '1:1']
        }
      }
    },
    content_restrictions: {
      single_photo: {
        message: {
          message: true,
          shorten_link_checkbox: true,
          emoji: true,
          hashtags: true,
          max_mediafiles: 1,
          image: true,
          gif: {
            is_animated: false
          }
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: true,
        targeting_and_visability: null
      },
      single_video: {
        message: {
          message: true,
          shorten_link_checkbox: true,
          emoji: true,
          hashtags: true,
          max_mediafiles: 1,
          gif: true
        },
        cards: null,
        video: {
          file: true,
          title: true,
          category: true
        },
        link: null,
        tag_people: false,
        enter_location: true,
        targeting_and_visability: null
      },
      multi_photo: {
        message: {
          message: true,
          shorten_link_checkbox: true,
          emoji: true,
          hashtags: true,
          max_mediafiles: 10,
          image: true,
          gif: {
            is_animated: false
          }
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: true,
        targeting_and_visability: null
      },
      media_carousel: {
        first_comment: {
          max_length: 2200,
        },
        message: {
          message: true,
          max_length: 2200,
          shorten_link_checkbox: true,
          emoji: true,
          hashtags: true,
          max_mediafiles: 10,
          image: true,
          gif: {
            is_animated: false
          }
        },
        cards: null,
        video: {
          file: true
        },
        link: null,
        tag_people: false,
        enter_location: true,
        targeting_and_visability: null
      },
      multi_video: {
        message: {
          message: true,
          shorten_link_checkbox: true,
          emoji: true,
          hashtags: true,
          max_mediafiles: 10,
          gif: true
        },
        cards: null,
        video: {
          file: true,
          title: true,
          category: true
        },
        link: null,
        tag_people: true,
        enter_location: true,
        targeting_and_visability: null
      },
      photo_story: {
        message: {
          max_mediafiles: 1,
          image: true,
          gif: true
        },
        cards: false,
        video: false,
        link: false,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: false
      },
      video_story: {
        message: {
          max_mediafiles: 1
        },
        cards: false,
        video: {
          file: true
        },
        link: false,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: false
      },
      reels: {
        message: {
          message: true,
          max_length: 2200,
          shorten_link_checkbox: true,
          emoji: true,
          hashtags: true,
          max_mediafiles: 1,
        },
        cards: false,
        video: {
          file: true
        },
        link: false,
        tag_people: false,
        enter_location: true,
        targeting_and_visability: false
      }
    }
  },
  linkedin: {
    media_restrictions: {
      default: {
        video: {
          valid_file_type: [
            'mov',
            'quicktime',
            'mp4',
            'x-msvideo',
            '3gpp',
            'mpeg',
            'ogg',
            'webm',
            'x-m4v',
            'ms-asf',
            'x-ms-wmv',
            'x-matroska'
          ],
          // max_videos_per_post: 1,
          max_size_mb: 5120,
          max_duration_sec: 600,
          min_duration_sec: 3,
          max_size_px: {
            width: 4096,
            height: 2304
          },
          min_size_px: {
            width: 256,
            height: 144
          },
          recommended_size: null,
          aspect_ratio: ['1:2.4', '2.4:1']
        },
        image: {
          supports_image: true,
          valid_file_type: ['jpg', 'jpeg', 'png'],
          max_mediafiles_per_post_carousel: 1,
          max_size_mb: 10,
          max_size_px: {
            width: null,
            height: null
          },
          min_size_px: {
            width: null,
            height: null
          },
          recommended_size: {
            '1.91:1': {
              width: 1200,
              height: 628
            }
          },
          aspect_ratio: ['1.91:1']
        }
      },
      animated_gif: {
        image: {
          valid_file_type: ['gif'],
          gif_is_animated: true
        }
      },
      link: null,
      single_photo: {
        image: {}
      },
      multi_photo: {
        image: {}
      },
      single_video: {
        video: {}
      },
      text: null
    },
    content_restrictions: {
      link: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false,
          max_mediafiles: 1,
          image: false,
          gif: true
        },
        cards: null,
        video: null,
        link: {
          link: true,
          link_name: true,
          link_description: true
        },
        tag_people: false,
        enter_location: false,
        targeting_and_visability: null
      },
      single_photo: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false,
          max_mediafiles: 1,
          image: true,
          gif: true
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: null
      },
      multi_photo: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false,
          max_mediafiles: 9,
          image: true,
          gif: true
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: null
      },
      single_video: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          max_mediafiles: 1,
          emoji: false,
          hashtags: false
        },
        cards: null,
        video: {
          file: true
        },
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: null
      },
      text: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: null
      }
    }
  },
  twitter: {
    media_restrictions: {
      default: {
        video: {
          supports_video: true,
          valid_file_type: [
            'mov',
            'quicktime',
            'mp4',
            'x-msvideo',
            '3gpp',
            'mpeg',
            'ogg',
            'webm',
            'x-m4v',
            'ms-asf',
            'x-ms-wmv',
            'x-matroska'
          ],
          // max_videos_per_post: 1,
          max_size_mb: 15,
          max_size_px: {
            width: 1280,
            height: 1024
          },
          min_size_px: {
            width: 32,
            height: 32
          },
          max_duration_sec: 140,
          min_duration_sec: 0.5,
          recommended_size: {
            '16:9': {
              width: 1280,
              height: 720
            },
            '9:16': {
              width: 720,
              height: 1280
            },
            '1:1': {
              width: 720,
              height: 720
            }
          },
          aspect_ratio: ['16:9', '9:16', '1:1']
        },
        image: {
          supports_image: true,
          valid_file_type: ['jpg', 'jpeg', 'png'],
          max_mediafiles_per_post_carousel: 4,
          max_size_mb: 5,
          max_size_px: {
            width: null,
            height: null
          },
          min_size_px: {
            width: null,
            height: null
          },
          recommended_size: {
            '16:9': {
              width: 1200,
              height: 675
            },
            '2:1': {
              width: 1024,
              height: 512
            }
          },
          aspect_ratio: ['16:9', '2:1', '7:8', '4:7']
        }
      },
      single_photo: {
        image: {}
      },
      multi_photo: {
        image: {}
      },
      single_video: {
        video: {}
      },
      animated_gif: {
        image: {
          valid_file_type: ['gif'],
          max_mediafiles_per_post_carousel: 1
        }
      },
      text: null
    },
    content_restrictions: {
      single_photo: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false,
          max_mediafiles: 1,
          image: true,
          gif: true
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: null
      },
      multi_photo: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false,
          max_mediafiles: 4,
          image: true,
          gif: true
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: null
      },
      single_video: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          max_mediafiles: 1,
          hashtags: false
        },
        cards: null,
        video: {
          file: true
        },
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: null
      },
      animated_gif: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false,
          max_mediafiles: 1,
          gif: true
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: null
      },
      text: {
        message: {
          message: true,
          shorten_link_checkbox: false,
          emoji: false,
          hashtags: false
        },
        cards: null,
        video: null,
        link: null,
        tag_people: false,
        enter_location: false,
        targeting_and_visability: null
      }
    }
  }
} as Restrictions

export default restrictions
